"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type FaqContactSectionProps = {
  title: string;
  description?: string;
  buttonText: string;
  className?: string;
};

const FaqContactSection = React.forwardRef<
  HTMLDivElement,
  FaqContactSectionProps
>(({ title, description, buttonText, className }, ref) => {
  const handleContact = () => {};

  return (
    <div className={cn("mt-16 text-center", className)} ref={ref}>
      <div className="mx-auto max-w-2xl space-y-4">
        <h3 className="font-bold font-heading text-foreground text-xl">
          {title}
        </h3>
        {description && (
          <p className="text-muted-foreground text-optimal">{description}</p>
        )}
        <div className="pt-2">
          <Button className="font-bold" onClick={handleContact} size="lg">
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
});

FaqContactSection.displayName = "FaqContactSection";

export { FaqContactSection };
